/**
 * =============================================================================
 *  THU TU CHONG LOP - MOT DINH NGHIA, HAI BEN DUNG
 * =============================================================================
 *
 *  Hop dong kieu (packages/types) noi ro ve `Annotation.z`:
 *
 *      "day la con so duy nhat quyet dinh thu tu, va no phai duoc phan anh vao
 *       THU TU GHI cua mang /Annots"
 *
 *  Truoc tep nay, chi co MOT ben giu loi hua do. Kho trang thai sap xep theo `z`
 *  de ve bang doi tuong; con duong ghi lay danh sach tu replayAnnotations(), ham
 *  tra ve theo THU TU THEM VAO va khong doc `z` bao gio.
 *
 *  Hau qua nhin thay duoc: nguoi dung bam "đưa lên trên một bậc", bang doi tuong
 *  doi cho ngay truoc mat, xuat tep ra thi hai hinh van chong nhau y nhu cu. Ban
 *  xem truoc noi doi - dung kieu loi ma bai hoc so 3 noi toi, chi khac la lan nay
 *  no o thu tu chu khong o hinh hoc.
 *
 *  Nen phep sap xep nam O DAY, trong core/annotations/, canh duong ghi. Kho trang
 *  thai xuat lai chinh ham nay chu khong giu mot ban sao.
 */
import type { Annotation } from '@pdfeditor/types';

/**
 * Sap xep chu thich theo thu tu chong lop: `z` nho hon ve TRUOC, tuc nam DUOI.
 *
 * Dau khong co `z` (du lieu cu, hoac dau tao truoc khi co truong nay) duoc coi
 * la z = 0 va GIU NGUYEN thu tu tuong doi voi nhau - Array.prototype.sort on
 * dinh theo dac ta ES2019. Nho vay mot tai lieu chua he duoc doi cho lan nao
 * van ghi ra dung thu tu them vao, y nhu truoc.
 */
export function sortAnnotationsByZ(list: readonly Annotation[]): Annotation[] {
  return [...list].sort((a, b) => (a.z ?? 0) - (b.z ?? 0));
}

/** Gia tri `z` cho mot dau moi: nam TREN tat ca nhung dau dang co. */
export function nextZAbove(list: readonly Annotation[]): number {
  let max = 0;
  for (const a of list) max = Math.max(max, a.z ?? 0);
  return max + 1;
}
